import { ReactElement, useRef, useMemo } from 'react'
import {
  BuildAndScaleSection,
  TrustNeededSection,
  WebsiteLayout,
  TrustedBySection,
  Testimonials,
  OurClientsAreFundedBy,
  HireOlbySection,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  FromOurBlogSection,
  WebsiteSeo,
} from '@platform/website-components'
import { Locale, useGetWebsiteCompanyPageQuery } from '@platform/data-access'
import { websiteFormatArticleList } from '@platform/utils'

const SEO = {
  title: 'For Companies // Olby',
  description:
    'Build and scale your tech team: Olby provides engaging tech talent from Brazil on-demand for enterprises and growing startups.',
}

export const ForCompanies = () => {
  const buildAndScaleRef = useRef<HTMLElement>(null)
  const trustedByRef = useRef<HTMLElement>(null)
  const trustNeededRef = useRef<HTMLElement>(null)
  const testimonialsRef = useRef<HTMLElement>(null)
  const ourClientsRef = useRef<HTMLElement>(null)
  const fromOurBlogRef = useRef<HTMLElement>(null)
  const hireOlbyRef = useRef<HTMLElement>(null)

  useUpdateHeader(buildAndScaleRef, HEADER_THEMES.EXT_BRAND_TEAL)
  useUpdateHeader(trustedByRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useUpdateHeader(trustNeededRef, HEADER_THEMES.PRIMARY_BRAND_BASE)
  useUpdateHeader(testimonialsRef, HEADER_THEMES.PRIMARY_BRAND_LOW)
  useUpdateHeader(ourClientsRef, HEADER_THEMES.EXT_BRAND_TEAL)
  useUpdateHeader(fromOurBlogRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(hireOlbyRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()

  const { data } = useGetWebsiteCompanyPageQuery({ input: { locale: Locale.En } })

  const posts = useMemo(() => {
    if (!data?.getWebsiteCompanyPage?.data) {
      return []
    }
    const list = data?.getWebsiteCompanyPage?.data.posts?.map(({ post }) => post)
    const formattedArticles = websiteFormatArticleList(list || [])
    return formattedArticles
  }, [data])

  return (
    <main>
      <WebsiteSeo seo={SEO} />
      <BuildAndScaleSection ref={buildAndScaleRef} />
      <TrustedBySection ref={trustedByRef} />
      <TrustNeededSection ref={trustNeededRef} />
      <Testimonials ref={testimonialsRef} />
      <OurClientsAreFundedBy ref={ourClientsRef} />
      <FromOurBlogSection posts={posts} ref={fromOurBlogRef} />
      <HireOlbySection ref={hireOlbyRef} />
    </main>
  )
}

export default ForCompanies

ForCompanies.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.EXT_BRAND_TEAL}>
      {page}
    </WebsiteLayout>
  )
}
